import { TipsItemKey } from '~/study-tips/types/studyTips.types'

interface TipsItemSettingType {
  itemClass?: string
}

const ItemSettings = {
  [TipsItemKey.STUDY_TECHNIQUE]: {
    itemClass: 'md:w-1/3',
  },
  [TipsItemKey.PROBLEM_SOLVING]: {
    itemClass: 'md:w-1/3',
  },
  [TipsItemKey.EXAM_TIPS]: {
    itemClass: 'md:w-1/2',
  },
  defaultSetting: {
    itemClass: 'md:w-1/3',
  },
}

// Hook for using different UI settings for study tips items list page. e.g. Two column/Three column
const useItemsSettings = (itemKey: TipsItemKey): TipsItemSettingType => {
  const settings = ItemSettings[itemKey]

  if (!settings) return ItemSettings.defaultSetting

  return settings
}

export default useItemsSettings
